export var HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE = 'com.atlassian.confluence.hub-element-placeholder';
export var HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY = 'hub-element-placeholder';